import { render, staticRenderFns } from "./BaseCreateForm.vue?vue&type=template&id=1cefac8a&scoped=true&"
import script from "./BaseCreateForm.vue?vue&type=script&lang=js&"
export * from "./BaseCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseCreateForm.vue?vue&type=style&index=0&id=1cefac8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cefac8a",
  null
  
)

export default component.exports